import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { cleanUpLocalStorage } from "./helpers";

export default function sessionReducer(state = initialState.session, action) {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
      return { ...state, jwt: action.jwt };
    case types.LOAD_CURRENT_USER_SUCCESS:
      return { ...state, currentUser: action.user };
    case types.UPDATE_PROFILE_SUCCESS:
      return { ...state, currentUser: action.user };
    case types.LOGIN_FAILED:
      cleanUpLocalStorage();
      return { ...state, jwt: "" };
    case types.LOGOUT_SUCCESS:
      cleanUpLocalStorage();
      return { ...state, jwt: "", currentUser: {} };
    default:
      return state;
  }
}
